import makeStyles from "@mui/styles/makeStyles";
import { styled } from "@mui/material";
import { colors } from "@zapalacorp/tokens";
import { FiEye } from "react-icons/fi";

import Button from "../../../../../../../components/Form/Button";

export const BadgeInactive = styled("div")(() => ({
  display: "inline-block",
  background: `${colors.error50} !important`,
  border: `1px solid ${colors.error50}`,
  padding: "8px 12px",
  borderRadius: 20,
  fontSize: "12px",
  fontWeight: 600,
  color: `${colors.error600} !important`,
}));

export const BadgeActive = styled(BadgeInactive)(() => ({
  background: `${colors.success50} !important`,
  borderColor: colors.success50,
  color: `${colors.success600} !important`,
}));

export const FiEyeButton = styled(FiEye)(() => ({
  cursor: "pointer",
}));

export const ChangeAllStatusButton = styled(Button)(() => ({
  whiteSpace: "nowrap",
  "& span > div": {
    display: "flex",
    alignItems: "center",
  },
}));

const styles = makeStyles(() => ({
  wrapper: {},
}));

export default styles;
